export declare const INJECTED_ENVIRONMENT: {
  PT_APPLICATION_NAME: string;
  PT_VERSION: string;
};

export function getEnvironment(): { PT_APPLICATION_NAME: string; PT_VERSION: string } {
  if (typeof INJECTED_ENVIRONMENT !== 'undefined') {
    return INJECTED_ENVIRONMENT;
  }

  // Cypress environment detection
  if (typeof window !== 'undefined' && (window as any).Cypress) {
    return {
      PT_APPLICATION_NAME: (window as any).Cypress.env('PT_APPLICATION_NAME') || 'Cypress Test',
      PT_VERSION: (window as any).Cypress.env('PT_VERSION') || '0.0.0-cypress',
    };
  }

  return {
    PT_APPLICATION_NAME: 'Test App',
    PT_VERSION: '0.0.0-test',
  };
}
